import { Button } from '@mui/material';
import React from 'react'


export default function DebugObjComp({ entity, colection, uidObj }) {
    const currentURL = window.location.href
    const inDebug = currentURL.includes("localhost") && !window.cordova
    if (!inDebug) {
        return ""
    }

    let srcFirestore = ""
    
    if (colection || entity.constructor.collectionUID) {
        srcFirestore = 'https://console.firebase.google.com/u/0/project/tchqualidade/firestore/data/~2F' + (colection || entity.constructor.collectionUID).replaceAll("/", '~2F')
        if (!srcFirestore.endsWith("~2F")) {
            srcFirestore = srcFirestore + "~2F"
        }
    }
    if (srcFirestore && (uidObj || entity.data.uid)) {
        srcFirestore += uidObj || entity.data.uid
    }

    return (
        <div style={{ position: 'fixed', bottom: 0 }}>

            {srcFirestore && <Button variant='contained' color='primary' onClick={() => {
                if (srcFirestore) {

                    window.open(srcFirestore, '_blank')
                }
            }}  >Ver Firebase</Button>}
            {entity && <Button variant='contained' color='primary' onClick={() => {
                console.log('entity', entity)
            }}  >Console</Button>}
        </div>
    )
}
